import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import * as Sentry from '@sentry/capacitor';
import * as SentryVue from '@sentry/vue';

export default defineNuxtPlugin(async (nuxtApp) => {
  const router = useRouter();
  const { isNativePlatform } = usePlatform();

  const { build, name } = isNativePlatform ? await App.getInfo() : { build: '1.0', name: 'web' };

  Sentry.init(
    {
      dsn: 'https://9c5bb8bea8c6bd3f5f4f1a8f0ad30378@o280857.ingest.us.sentry.io/4507768730681344',
      release: name,
      dist: build,
      environment: isNativePlatform ? Capacitor.getPlatform() : process.env.NUXT_PUBLIC_ENVIRONMENT,
      integrations: [SentryVue.browserTracingIntegration({ router })],
      tracesSampleRate: 1.0,
      tracePropagationTargets: ['localhost', /^\//],
      siblingOptions: {
        vueOptions: {
          app: nuxtApp.vueApp,
          attachProps: true,
          attachErrorHandler: true
        }
      }
    },
    SentryVue.init
  );
});
